module.exports = "/static/assets/b0f62f01106e1485949e203cb8df4134.png";